const moment = require('moment')
const momentDurationFormatSetup = require('moment-duration-format')
momentDurationFormatSetup(moment)

const TIME = {
	install (Vue, options) {
		Vue.prototype.$time = {

			fromDate (date) {
				moment.updateLocale('fr', {
					relativeTime: {
						future: 'Dans %s',
						past: 'Il y a %s',
						s: 'quelques secondes',
						ss: '%d secondes',
						m: '1 minute',
						mm: '%d minutes',
						h: '1 heure',
						hh: '%d heures',
						d: '1 jour',
						dd: '%d jours',
						w: '1 semaine',
						ww: '%d semaines',
						M: '1 mois',
						MM: '%d mois',
						y: '1 an',
						yy: '%d ans'
					}
				})
				let from = moment(date).fromNow()
				if (from === 'Invalid date') from = null
				return from
			},

			humanizeDate (date) {
				if (!date) return ''
				return moment(date).format('DD/MM/YY HH:mm:ss')
			},

			humanizeDurationSeconds (value) {
				if (!value) return '0 s'
				if (!parseFloat(value)) return '-'
				let seconds = parseFloat(value)
				let duration = moment.duration(seconds, 'seconds')
				// SECONDS
				if (seconds < 60) {
					return duration.format('s [s]', { trim: false })
				}
				// MINUTES
				if (seconds < 3600) {
					return duration.format('m [m] s [s]', { trim: false })
				}
				// HOURS
				return duration.format('H [h] m [m] s [s]', { trim: false })
			},

			secondsToTcMs (seconds) {
				if (parseFloat(seconds)) {
					return moment.duration(parseFloat(seconds), 'seconds')
						.format('HH:mm:ss:SSS', { trim: false })
				}
				return 0
			},

			secondsToHMS (seconds) {
				if (parseFloat(seconds)) {
					return moment.duration(parseFloat(seconds), 'seconds')
						.format('HH:mm:ss', { trim: false })
				}
				return 0
			},

			dateMsToDate (datems) {
				var date = new Date(datems)
				var yr = date.getFullYear()
				var mo = date.getMonth() + 1
				mo = mo.toString().padStart(2, '0')
				var da = date.getDate()
				da = da.toString().padStart(2, '0')
				var ho = date.getHours()
				ho = ho.toString().padStart(2, '0')
				var mi = date.getMinutes()
				mi = mi.toString().padStart(2, '0')
				var se = date.getSeconds()
				se = se.toString().padStart(2, '0')
				return yr + '-' + mo + '-' + da + ' ' + ho + ':' + mi + ':' + se
			}

		}
	}
}

export default TIME



// WEBPACK FOOTER //
// ./src/plugins/time.js